var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "901px",
    height: "399px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M -0.5,-0.5 C 299.833,-0.5 600.167,-0.5 900.5,-0.5C 900.5,132.5 900.5,265.5 900.5,398.5C 600.167,398.5 299.833,398.5 -0.5,398.5C -0.5,265.5 -0.5,132.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e60302",
    d: "M 861.5,40.5 C 861.264,51.0422 861.93,61.3755 863.5,71.5C 865.238,122.51 867.238,173.51 869.5,224.5C 869.5,229.5 869.5,234.5 869.5,239.5C 863.642,239.178 857.975,239.511 852.5,240.5C 713.512,246.735 574.512,252.735 435.5,258.5C 422.642,258.442 409.975,259.109 397.5,260.5C 395.5,260.5 393.5,260.5 391.5,260.5C 379.303,260.376 367.303,261.042 355.5,262.5C 337.808,262.646 320.141,263.313 302.5,264.5C 287.65,264.566 272.984,265.232 258.5,266.5C 229.659,267.443 200.992,268.776 172.5,270.5C 126.852,272.638 81.1853,274.305 35.5,275.5C 35.7373,274.209 35.404,273.209 34.5,272.5C 34.81,269.287 34.4767,266.287 33.5,263.5C 33.4699,243.142 32.8032,222.808 31.5,202.5C 31.6578,190.634 30.9911,178.967 29.5,167.5C 29.3082,149.464 28.6416,131.464 27.5,113.5C 27.4161,101.98 26.7494,90.6464 25.5,79.5C 25.5,72.8333 25.5,66.1667 25.5,59.5C 25.5,56.1667 25.5,52.8333 25.5,49.5C 28.5,49.5 31.5,49.5 34.5,49.5C 45.0382,49.6752 55.3715,49.0085 65.5,47.5C 289.164,37.7085 512.83,28.0418 736.5,18.5C 748.369,18.7141 760.036,18.0474 771.5,16.5C 801.482,14.9929 831.482,13.9929 861.5,13.5C 861.5,22.5 861.5,31.5 861.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ed5a53",
    d: "M 771.5,16.5 C 760.036,18.0474 748.369,18.7141 736.5,18.5C 747.978,17.2139 759.645,16.5472 771.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f16f6e",
    d: "M 34.5,48.5 C 34.5,48.8333 34.5,49.1667 34.5,49.5C 31.5,49.5 28.5,49.5 25.5,49.5C 25.5,52.8333 25.5,56.1667 25.5,59.5C 24.5184,56.0381 24.185,52.3714 24.5,48.5C 27.8333,48.5 31.1667,48.5 34.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ea3932",
    d: "M 65.5,47.5 C 55.3715,49.0085 45.0382,49.6752 34.5,49.5C 34.5,49.1667 34.5,48.8333 34.5,48.5C 44.8214,47.8673 55.1547,47.534 65.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f48a88",
    d: "M 861.5,40.5 C 862.94,50.6328 863.607,60.9661 863.5,71.5C 861.93,61.3755 861.264,51.0422 861.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfb",
    d: "M 721.5,186.5 C 721.49,173.645 720.823,160.978 719.5,148.5C 719.083,127.491 718.416,106.491 717.5,85.5C 717.5,83.1667 717.5,80.8333 717.5,78.5C 720.385,78.8064 723.052,78.4731 725.5,77.5C 738.161,76.7224 750.827,76.5557 763.5,77C 776.126,78.2952 783.626,85.1285 786,97.5C 788.214,110.385 784.714,121.385 775.5,130.5C 780.297,133.796 783.797,138.129 786,143.5C 787.657,152.088 788.657,160.755 789,169.5C 789.552,174.564 791.385,179.064 794.5,183C 786.827,183.402 779.16,183.902 771.5,184.5C 769.5,184.167 767.5,183.833 765.5,183.5C 764.366,180.93 763.532,178.264 763,175.5C 762.915,166.425 762.248,157.425 761,148.5C 759.833,146 758,144.167 755.5,143C 752.183,142.502 748.85,142.335 745.5,142.5C 745.647,156.839 745.98,171.172 746.5,185.5C 738.164,185.782 729.831,186.116 721.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfb",
    d: "M 668.5,113.5 C 668.5,116.167 668.5,118.833 668.5,121.5C 673.363,121.819 678.03,121.486 682.5,120.5C 688.5,120.5 694.5,120.5 700.5,120.5C 700.5,123.833 700.5,127.167 700.5,130.5C 700.5,134.167 700.5,137.833 700.5,141.5C 696.958,141.187 693.625,141.521 690.5,142.5C 683.833,142.5 677.167,142.5 670.5,142.5C 670.5,150.5 670.5,158.5 670.5,166.5C 682.163,166.062 693.83,165.728 705.5,165.5C 705.5,172.833 705.5,180.167 705.5,187.5C 685.852,188.571 666.185,189.237 646.5,189.5C 645.485,153.485 644.152,117.485 642.5,81.5C 662.145,80.3818 681.811,79.7151 701.5,79.5C 701.5,86.5 701.5,93.5 701.5,100.5C 690.486,100.457 679.486,100.791 668.5,101.5C 668.5,105.5 668.5,109.5 668.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f28182",
    d: "M 725.5,77.5 C 723.052,78.4731 720.385,78.8064 717.5,78.5C 717.5,80.8333 717.5,83.1667 717.5,85.5C 716.527,83.0521 716.194,80.3854 716.5,77.5C 719.5,77.5 722.5,77.5 725.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfb",
    d: "M 558.5,94.5 C 558.5,91.5 558.5,88.5 558.5,85.5C 561.713,85.81 564.713,85.4767 567.5,84.5C 578.823,83.6116 590.156,83.4449 601.5,84C 616,86.5 624.5,95 627,109.5C 629.513,129.816 629.846,150.149 628,170.5C 623.809,184.529 614.309,191.696 599.5,192C 587.182,192.933 574.849,193.433 562.5,193.5C 561.027,160.506 559.693,127.506 558.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfb",
    d: "M 542.5,156.5 C 543.506,163.971 544.506,171.305 545.5,178.5C 545.477,184.082 547.144,189.082 550.5,193.5C 540.827,194.852 531.161,195.185 521.5,194.5C 519.855,190.675 519.188,186.675 519.5,182.5C 519.666,175.492 519.5,168.492 519,161.5C 518.722,160.584 518.222,159.918 517.5,159.5C 516.797,157.284 515.464,155.451 513.5,154C 509.605,152.734 505.605,152.234 501.5,152.5C 502.155,167.158 502.488,181.824 502.5,196.5C 498.167,196.5 493.833,196.5 489.5,196.5C 485.833,196.5 482.167,196.5 478.5,196.5C 478.737,195.209 478.404,194.209 477.5,193.5C 476.141,158.5 474.808,123.5 473.5,88.5C 489.169,88.0275 504.836,87.8608 520.5,88C 535.089,90.5851 542.422,99.2518 542.5,114C 542.39,119.205 541.89,124.372 541,129.5C 538.588,133.916 535.422,137.749 531.5,141C 537.707,144.372 541.373,149.539 542.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef8682",
    d: "M 567.5,84.5 C 564.713,85.4767 561.713,85.81 558.5,85.5C 558.5,88.5 558.5,91.5 558.5,94.5C 557.521,91.3752 557.187,88.0419 557.5,84.5C 560.833,84.5 564.167,84.5 567.5,84.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfa",
    d: "M 457.5,116.5 C 457.527,122.051 458.194,127.384 459.5,132.5C 460.646,145.091 460.812,157.758 460,170.5C 458.618,188.379 449.118,198.712 431.5,201.5C 424.465,201.674 417.465,201.341 410.5,200.5C 399.277,196.463 392.443,188.463 390,176.5C 386.67,155.232 386.003,133.898 388,112.5C 393.567,96.2773 405.067,88.2773 422.5,88.5C 441.936,88.2803 453.602,97.6136 457.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfa",
    d: "M 332.5,105.5 C 332.5,108.833 332.5,112.167 332.5,115.5C 325.646,115.176 318.979,115.509 312.5,116.5C 308.366,117.485 304.032,117.818 299.5,117.5C 299.454,124.191 299.788,130.857 300.5,137.5C 310.824,136.922 321.157,136.588 331.5,136.5C 332.118,143.817 332.451,151.151 332.5,158.5C 327.833,158.5 323.167,158.5 318.5,158.5C 312.833,158.5 307.167,158.5 301.5,158.5C 301.174,166.684 301.508,174.684 302.5,182.5C 313.819,181.778 325.152,181.445 336.5,181.5C 336.5,184.5 336.5,187.5 336.5,190.5C 336.5,194.833 336.5,199.167 336.5,203.5C 329.313,203.175 322.313,203.509 315.5,204.5C 302.847,205.228 290.18,205.561 277.5,205.5C 276.658,169.473 275.325,133.473 273.5,97.5C 293.151,96.4282 312.818,95.7616 332.5,95.5C 332.5,98.8333 332.5,102.167 332.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e60f09",
    d: "M 752.5,96.5 C 756.063,96.6252 758.563,98.2919 760,101.5C 763.87,116.113 758.37,123.113 743.5,122.5C 743.5,115.167 743.5,107.833 743.5,100.5C 743.5,99.1667 743.5,97.8333 743.5,96.5C 746.5,96.5 749.5,96.5 752.5,96.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ee6766",
    d: "M 752.5,96.5 C 749.5,96.5 746.5,96.5 743.5,96.5C 743.5,97.8333 743.5,99.1667 743.5,100.5C 742.549,99.0813 742.216,97.4147 742.5,95.5C 746.042,95.1872 749.375,95.5206 752.5,96.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfa",
    d: "M 217.5,182.5 C 217.5,191.167 217.5,199.833 217.5,208.5C 213.958,208.187 210.625,208.521 207.5,209.5C 202.833,209.5 198.167,209.5 193.5,209.5C 192.277,176.161 190.944,142.828 189.5,109.5C 189.5,106.833 189.5,104.167 189.5,101.5C 192.713,101.81 195.713,101.477 198.5,100.5C 207.002,100.286 215.502,99.9523 224,99.5C 240.877,97.2562 252.21,103.923 258,119.5C 260.577,132.839 257.077,144.172 247.5,153.5C 253.324,157.814 257.158,163.48 259,170.5C 259.589,179.545 260.589,188.545 262,197.5C 262.973,200.779 264.473,203.779 266.5,206.5C 256.833,207.833 247.167,207.833 237.5,206.5C 235.304,194.934 233.804,183.268 233,171.5C 232.226,169.061 230.726,167.227 228.5,166C 224.848,165.501 221.182,165.335 217.5,165.5C 217.5,171.167 217.5,176.833 217.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2817d",
    d: "M 198.5,100.5 C 195.713,101.477 192.713,101.81 189.5,101.5C 189.5,104.167 189.5,106.833 189.5,109.5C 188.523,106.713 188.19,103.713 188.5,100.5C 191.833,100.5 195.167,100.5 198.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefcfc",
    d: "M 150.5,169.5 C 145.167,169.5 139.833,169.5 134.5,169.5C 134.334,177.174 134.5,184.841 135,192.5C 135.191,194.708 135.691,196.708 136.5,198.5C 136.5,203.167 136.5,207.833 136.5,212.5C 133.5,212.5 130.5,212.5 127.5,212.5C 122.167,212.5 116.833,212.5 111.5,212.5C 111.601,201.302 110.934,190.302 109.5,179.5C 109.152,158.822 108.485,138.155 107.5,117.5C 107.5,113.5 107.5,109.5 107.5,105.5C 112.363,105.819 117.03,105.486 121.5,104.5C 133.192,103.025 144.859,103.191 156.5,105C 170.675,110.323 177.342,120.657 176.5,136C 177.634,155.009 168.968,166.176 150.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e6120a",
    d: "M 584.5,104.5 C 596.202,102.047 602.035,106.713 602,118.5C 602.648,128.826 603.148,139.16 603.5,149.5C 603.537,155.554 603.037,161.554 602,167.5C 597.818,171.925 592.652,173.592 586.5,172.5C 586.036,149.827 585.369,127.16 584.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8bfbc",
    d: "M 121.5,104.5 C 117.03,105.486 112.363,105.819 107.5,105.5C 107.5,109.5 107.5,113.5 107.5,117.5C 106.515,113.366 106.182,109.032 106.5,104.5C 111.5,104.5 116.5,104.5 121.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e61009",
    d: "M 430.5,113.5 C 430.41,116.152 431.076,118.485 432.5,120.5C 434.498,138.749 434.998,157.083 434,175.5C 430.252,181.542 425.085,183.042 418.5,180C 416.009,176.26 414.509,172.093 414,167.5C 412.862,150.177 412.529,132.844 413,115.5C 415.768,109.828 420.268,107.994 426.5,110C 428.324,110.66 429.657,111.827 430.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e6120a",
    d: "M 499.5,106.5 C 513.843,105.01 519.677,111.343 517,125.5C 513.061,131.21 507.561,133.544 500.5,132.5C 499.797,123.851 499.464,115.185 499.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7b8b7",
    d: "M 25.5,79.5 C 26.7494,90.6464 27.4161,101.98 27.5,113.5C 26.0358,102.366 25.3691,91.0322 25.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbd4d4",
    d: "M 332.5,105.5 C 333.482,108.962 333.815,112.629 333.5,116.5C 326.5,116.5 319.5,116.5 312.5,116.5C 318.979,115.509 325.646,115.176 332.5,115.5C 332.5,112.167 332.5,108.833 332.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef6562",
    d: "M 430.5,113.5 C 431.924,115.515 432.59,117.848 432.5,120.5C 431.076,118.485 430.41,116.152 430.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e60c07",
    d: "M 223.5,119.5 C 227.562,119.724 230.395,121.724 232,125.5C 235.383,139.611 229.883,146.278 215.5,145.5C 215.5,141.5 215.5,137.5 215.5,133.5C 215.5,128.833 215.5,124.167 215.5,119.5C 218.167,119.5 220.833,119.5 223.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef6967",
    d: "M 668.5,113.5 C 669.468,115.607 669.802,117.941 669.5,120.5C 673.833,120.5 678.167,120.5 682.5,120.5C 678.03,121.486 673.363,121.819 668.5,121.5C 668.5,118.833 668.5,116.167 668.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e6170e",
    d: "M 133.5,123.5 C 149.717,122.917 154.883,130.25 149,145.5C 144.868,150.048 139.701,151.715 133.5,150.5C 133.5,141.5 133.5,132.5 133.5,123.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f69d9a",
    d: "M 457.5,116.5 C 458.957,121.598 459.624,126.931 459.5,132.5C 458.194,127.384 457.527,122.051 457.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f69694",
    d: "M 223.5,119.5 C 220.833,119.5 218.167,119.5 215.5,119.5C 215.5,124.167 215.5,128.833 215.5,133.5C 214.513,128.695 214.179,123.695 214.5,118.5C 217.713,118.19 220.713,118.523 223.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5a8a8",
    d: "M 700.5,130.5 C 701.483,134.298 701.817,138.298 701.5,142.5C 697.833,142.5 694.167,142.5 690.5,142.5C 693.625,141.521 696.958,141.187 700.5,141.5C 700.5,137.833 700.5,134.167 700.5,130.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef6e68",
    d: "M 318.5,158.5 C 313.36,159.488 308.026,159.821 302.5,159.5C 302.5,167.167 302.5,174.833 302.5,182.5C 301.508,174.684 301.174,166.684 301.5,158.5C 307.167,158.5 312.833,158.5 318.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eb4237",
    d: "M 542.5,156.5 C 543.963,159.203 544.796,162.203 545,165.5C 545.645,166.646 546.478,167.646 547.5,168.5C 545.711,171.556 545.044,174.889 545.5,178.5C 544.506,171.305 543.506,163.971 542.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fabdb9",
    d: "M 150.5,169.5 C 145.695,170.487 140.695,170.821 135.5,170.5C 136,179.826 136.333,189.159 136.5,198.5C 135.691,196.708 135.191,194.708 135,192.5C 134.5,184.841 134.334,177.174 134.5,169.5C 139.833,169.5 145.167,169.5 150.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f18785",
    d: "M 517.5,159.5 C 518.222,159.918 518.722,160.584 519,161.5C 519.5,168.492 519.666,175.492 519.5,182.5C 518.696,174.988 518.03,167.321 517.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eb4640",
    d: "M 719.5,148.5 C 720.823,160.978 721.49,173.645 721.5,186.5C 719.993,174.031 719.326,161.364 719.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5c0c2",
    d: "M 477.5,193.5 C 478.404,194.209 478.737,195.209 478.5,196.5C 482.167,196.5 485.833,196.5 489.5,196.5C 485.702,197.483 481.702,197.817 477.5,197.5C 477.5,196.167 477.5,194.833 477.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f28682",
    d: "M 336.5,190.5 C 337.486,194.97 337.819,199.637 337.5,204.5C 330.167,204.5 322.833,204.5 315.5,204.5C 322.313,203.509 329.313,203.175 336.5,203.5C 336.5,199.167 336.5,194.833 336.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f79a97",
    d: "M 29.5,167.5 C 30.9911,178.967 31.6578,190.634 31.5,202.5C 29.9015,191.039 29.2348,179.372 29.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5b1ad",
    d: "M 410.5,200.5 C 417.465,201.341 424.465,201.674 431.5,201.5C 428.686,202.165 425.686,202.498 422.5,202.5C 418.203,202.722 414.203,202.055 410.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f69997",
    d: "M 217.5,182.5 C 218.493,191.318 218.827,200.318 218.5,209.5C 214.833,209.5 211.167,209.5 207.5,209.5C 210.625,208.521 213.958,208.187 217.5,208.5C 217.5,199.833 217.5,191.167 217.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f27f7b",
    d: "M 109.5,179.5 C 110.934,190.302 111.601,201.302 111.5,212.5C 116.833,212.5 122.167,212.5 127.5,212.5C 122.025,213.489 116.358,213.822 110.5,213.5C 109.913,202.176 109.58,190.843 109.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f48a87",
    d: "M 869.5,224.5 C 870.488,229.64 870.821,234.974 870.5,240.5C 864.5,240.5 858.5,240.5 852.5,240.5C 857.975,239.511 863.642,239.178 869.5,239.5C 869.5,234.5 869.5,229.5 869.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f48e8c",
    d: "M 435.5,258.5 C 423.022,259.823 410.355,260.49 397.5,260.5C 409.975,259.109 422.642,258.442 435.5,258.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8aeac",
    d: "M 391.5,260.5 C 379.703,262.068 367.703,262.735 355.5,262.5C 367.303,261.042 379.303,260.376 391.5,260.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fab8b6",
    d: "M 302.5,264.5 C 288.034,266.15 273.367,266.817 258.5,266.5C 272.984,265.232 287.65,264.566 302.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#910202",
    d: "M 172.5,270.5 C 172.5,270.833 172.5,271.167 172.5,271.5C 167.612,274.175 162.445,275.175 157,274.5C 124.121,277.423 90.9542,279.923 57.5,282C 55.9336,282.608 54.6002,283.442 53.5,284.5C 47.7192,282.443 42.0526,280.11 36.5,277.5C 35.032,276.221 34.3653,274.554 34.5,272.5C 35.404,273.209 35.7373,274.209 35.5,275.5C 81.1853,274.305 126.852,272.638 172.5,270.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9e0302",
    d: "M 172.5,271.5 C 174.156,273.46 175.823,275.46 177.5,277.5C 158.344,279.089 139.011,280.255 119.5,281C 111.365,282.799 103.199,283.299 95,282.5C 86.2409,284.442 77.4076,285.775 68.5,286.5C 68.1667,285.833 67.8333,285.167 67.5,284.5C 66.7379,285.628 66.0712,286.795 65.5,288C 66.756,288.417 67.4226,289.25 67.5,290.5C 62.5709,288.85 57.9043,286.85 53.5,284.5C 54.6002,283.442 55.9336,282.608 57.5,282C 90.9542,279.923 124.121,277.423 157,274.5C 162.445,275.175 167.612,274.175 172.5,271.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3bdbb",
    d: "M 33.5,263.5 C 34.4767,266.287 34.81,269.287 34.5,272.5C 34.3653,274.554 35.032,276.221 36.5,277.5C 35.5,277.5 34.5,277.5 33.5,277.5C 33.5,272.833 33.5,268.167 33.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#af0201",
    d: "M 177.5,277.5 C 180.411,280.99 183.078,284.656 185.5,288.5C 184.5,288.5 183.5,288.5 182.5,288.5C 182.5,287.5 182.5,286.5 182.5,285.5C 168.328,286.749 153.994,287.582 139.5,288C 132.667,290.644 125.667,291.144 118.5,289.5C 114.585,290.033 111.085,291.366 108,293.5C 105.521,292.755 103.021,292.089 100.5,291.5C 96.2393,292.725 91.9059,293.558 87.5,294C 86.8753,295.64 86.8753,297.473 87.5,299.5C 80.5539,296.863 73.8872,293.863 67.5,290.5C 67.4226,289.25 66.756,288.417 65.5,288C 66.0712,286.795 66.7379,285.628 67.5,284.5C 67.8333,285.167 68.1667,285.833 68.5,286.5C 77.4076,285.775 86.2409,284.442 95,282.5C 103.199,283.299 111.365,282.799 119.5,281C 139.011,280.255 158.344,279.089 177.5,277.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bf0301",
    d: "M 185.5,288.5 C 187.522,290.531 189.189,292.865 190.5,295.5C 189.211,297.248 187.711,297.581 186,296.5C 185.395,298.481 184.395,298.815 183,297.5C 181.731,298.905 181.231,300.571 181.5,302.5C 165.767,302.851 150.1,304.018 134.5,306C 131.724,306.066 129.558,307.232 128,309.5C 126.991,308.342 125.658,307.675 124,307.5C 121.283,307.93 119.116,309.263 117.5,311.5C 117.863,312.183 118.196,312.85 118.5,313.5C 108.044,309.105 97.7102,304.438 87.5,299.5C 86.8753,297.473 86.8753,295.64 87.5,294C 91.9059,293.558 96.2393,292.725 100.5,291.5C 103.021,292.089 105.521,292.755 108,293.5C 111.085,291.366 114.585,290.033 118.5,289.5C 125.667,291.144 132.667,290.644 139.5,288C 153.994,287.582 168.328,286.749 182.5,285.5C 182.5,286.5 182.5,287.5 182.5,288.5C 183.5,288.5 184.5,288.5 185.5,288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d20603",
    d: "M 190.5,295.5 C 208.691,320.021 227.024,344.521 245.5,369C 245,369.167 244.5,369.333 244,369.5C 201.94,351.218 160.107,332.551 118.5,313.5C 118.196,312.85 117.863,312.183 117.5,311.5C 119.116,309.263 121.283,307.93 124,307.5C 125.658,307.675 126.991,308.342 128,309.5C 129.558,307.232 131.724,306.066 134.5,306C 150.1,304.018 165.767,302.851 181.5,302.5C 181.231,300.571 181.731,298.905 183,297.5C 184.395,298.815 185.395,298.481 186,296.5C 187.711,297.581 189.211,297.248 190.5,295.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreorder);
export default __webpack_public_path__ + "static/media/preorder.798ab6145347ae553fa3916f9a19b0b5.svg";
export { ForwardRef as ReactComponent };